import { call, put, takeLatest } from "redux-saga/effects";
import { getActivePeriodId } from "../../../api/apiClient";
import { classesApi } from "../../../api/classes/classesApi";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IClassListItem } from "../../../model/respone/classes/IClassListItem";
import { eClassesActionTypeIds } from "../../action-types/classes/IClassesActions";
import { rootActions } from "../../actions/rootActions";

export function* classesSaga(): any {
    yield takeLatest(eClassesActionTypeIds.LOAD_START, loadWorker);
}

function* loadWorker(): any {
    const res: IBaseRespone<IClassListItem[]> = yield call(classesApi.GetList);
    if (res.is_success && res.data) {
        yield put(rootActions.classes.LOAD_SUCCESS({
            list: res.data,
            periodId: getActivePeriodId() ?? undefined,
        }));
    } else {
        yield put(rootActions.classes.LOAD_ERROR(res.message || "Không tải được danh sách lớp."));
    }
}
